export default __webpack_public_path__ + "static/media/25.6deb5ad1.jpeg";